import { BigNumber } from 'bignumber.js';

export function formatDecimalPlaces(value: number | string, minDp: number, maxDp?: number): string {
  const n = BigNumber(value);

  const numMinDp = n.toFormat(minDp);
  const numMaxDp = typeof maxDp === 'number' ? n.toFormat(maxDp) : n.toFormat();
  const numDefault = n.toFormat();

  if (numDefault.length < numMinDp.length) {
    return numMinDp;
  }

  if (numDefault.length > numMaxDp.length) {
    return numMaxDp;
  }

  return numDefault;
}

export function sumBigNumbers(numbers: BigNumber[], skipNaN = true): BigNumber {
  return numbers.reduce((sum, number) => {
    if (number.isNaN()) {
      if (!skipNaN) {
        throw new Error('NaN value encountered when calculating sum');
      }

      return sum;
    }

    return sum.plus(number);
  }, BigNumber(0));
}
